import { produce } from 'immer';
import moment from 'moment';
import {
  fetchLocationPolling,
  fetchQrCodeToken,
  fetchReleaseBeforeAuditCheck,
} from '@/services/release-before-audit';
import { Modal } from 'antd';
import { calculateDistance } from '@/utils/logicUtils';

const DEFAULT_STATE = {
  init: false, // 初始化阶段获取是否先发后审
  submit: false, // 提交阶段获取是否先发后审
  role: null, // 客服先发后审角色类型字段 dz / dc
  shopLocation: null,
  userLocation: null,
  userLocationExpiration: null,
  qrCodeVisible: false,
  qrCodeToken: null,
  qrCodeTokenExpiration: null,
  farWarningModalVisible: false,
};

const delay = ms =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

export const confirmModalPromise = () => {
  return new Promise((resolve, reject) => {
    Modal.confirm({
      centered: true,
      title: '确定在实地提交吗？',
      content: (
        <span>
          若您不在现场或无法保证门店真实性，请切勿选择“现场提交”。
          <span style={{ color: '#ff0000' }}>
            若您提交虚假信息，将根据公司相关制度予以违规处罚。
          </span>
        </span>
      ),
      cancelText: '取消',
      okText: '确认',
      onOk: () => {
        resolve('OK');
      },
      onCancel: () => {
        resolve('Cancel');
      },
    });
  });
};

export default {
  namespace: 'releaseBeforeAudit',
  state: { ...DEFAULT_STATE },
  effects: {
    *distanceCheck({ payload }, { put, select }) {
      const { shopLocation, userLocation } = yield select(state => state.releaseBeforeAudit);
      console.log('[Debug] distanceCheck', shopLocation, userLocation);
      if (!shopLocation?.lng || !userLocation?.lng) return null;
      const distance = calculateDistance(
        shopLocation.lat,
        shopLocation.lng,
        userLocation.lat,
        userLocation.lng
      );
      yield put({
        type: 'update',
        payload: {
          distanceCheck: distance <= 3,
          farWarningModalVisible: distance > 3,
        },
      });
      console.log('[Debug] distance', distance);
      if (distance > 3) yield put({ type: 'user/lx', payload: ['b_pdc_lvlkjinq_mc'] });
      yield put({
        type: 'user/lx',
        payload: [
          'b_pdc_11851xgs_mc',
          {
            custom: {
              uat: `--${userLocation.lat}`,
              ung: `--${userLocation.lng}`,
              sat: `--${shopLocation.lat}`,
              sng: `--${shopLocation.lng}`,
              distance,
            },
          },
        ],
      });
      return distance <= 3;
    },
    *pollingLocation({ payload }, { call, put }) {
      const data = yield call(fetchLocationPolling, payload);
      console.log('[Debug] pollingLocation', data);
      if (data?.length) {
        const [lng, lat] = data.split(',');
        const userLocation = { lng: +lng, lat: +lat };
        yield put({
          type: 'update',
          payload: {
            userLocation,
            userLocationExpiration: moment().add(10, 'seconds'),
          },
        });
        yield call(delay, 1000);
        yield put({
          type: 'update',
          payload: {
            qrCodeVisible: false,
            qrCodeToken: null,
            qrCodeTokenExpiration: null,
          },
        });
        console.log('[Debug] get pollingLocation', userLocation);
        return { userLocation, distanceCheck: yield yield put({ type: 'distanceCheck' }) };
      }
      return false;
    },
    *getLocationByQrCode({ payload }, { call, put, select }) {
      const releaseBeforeAudit = yield select(state => state.releaseBeforeAudit);
      if (
        releaseBeforeAudit.userLocationExpiration &&
        moment().isBefore(releaseBeforeAudit.userLocationExpiration)
      ) {
        return yield put({ type: 'distanceCheck' });
      }
      yield put({
        type: 'update',
        payload: {
          userLocation: null,
          userLocationExpiration: null,
        },
      });
      if (!payload?.refresh) {
        yield put({
          type: 'user/mv',
          payload: ['b_pdc_sg8y7t9n_mv'],
        });
        const choice = yield call(confirmModalPromise);
        yield put({
          type: 'user/mc',
          payload: [choice === 'OK' ? 'b_pdc_5zyhe7b5_mc' : 'b_pdc_eyo6x2im_mc'],
        });
        if (choice !== 'OK') return;
      }
      const data = yield call(fetchQrCodeToken);
      if (data?.token) {
        yield put({
          type: 'update',
          payload: {
            qrCodeVisible: true,
            qrCodeToken: data.token,
            qrCodeTokenExpiration: moment().add(5, 'minutes'),
          },
        });
      }
    },
    *fetchCheck({ payload }, { call, put }) {
      const { pageType, predictType, ...submitParams } = payload;
      const data = yield call(fetchReleaseBeforeAuditCheck, {
        pageType,
        predictType,
        ...submitParams,
      });
      const key = predictType === 1 ? 'submit' : 'init';
      yield put({
        type: 'update',
        payload: {
          [key]: !!data?.publishBeforeAudit,
          role: data?.callCenterServiceType,
        },
      });
      return !!data?.publishBeforeAudit;
    },
  },
  reducers: {
    update(state, { payload }) {
      return produce(state, draft => {
        Object.keys(payload).forEach(key => {
          draft[key] = payload[key];
        });
      });
    },
    init(state, action) {
      return produce(state, draft => {
        Object.keys(DEFAULT_STATE).forEach(key => {
          draft[key] = DEFAULT_STATE[key];
        });
      });
    },
  },
};
